import { makeStyles, Theme, createStyles } from '@material-ui/core'
import colors from '../../../styles/colors'
import palette from '../../../styles/palette'

/**
 * Header do mockup Lovable: barra translúcida sobre o fundo da página (não
 * um bloco branco), setas de navegação como botões circulares e o avatar
 * como pílula `brand-soft` com borda `brand/30`.
 */
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerHeader: {
      display: 'flex',
      alignItems: 'center',
      position: 'fixed',
      justifyContent: 'end',
      backgroundColor: colors.grayLight,
      /* `left/right` no lugar de `width: 100%`: a faixa passa a ser esticada
         entre as bordas, e o `marginLeft` dinâmico (aplicado no componente
         com a largura da sidebar) a RECORTA — assim a banda nunca passa por
         baixo da sidebar, nem transientemente. Com `width: 100%` + margem, a
         banda transbordava à direita e dependia de flex-shrink para caber. */
      left: 0,
      right: 0,
      top: 0,
      zIndex: 2,
      transition: 'margin .25s ease',
      [theme.breakpoints.between(0, 1200)]: {
        backgroundColor: colors.purpleDark,
      },
    },
    boxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 40,
      paddingRight: 40,
      /* Sem `marginLeft` aqui: o afastamento da sidebar é da faixa inteira
         (containerHeader), não desta linha. A regra antiga de margem nesta
         faixa de largura disputava com o prop `ml` do MUI v5 e, quando
         ganhava, jogava o conteúdo do header para debaixo da sidebar. */
      [theme.breakpoints.between('xs', 'lg')]: {
        width: '100%',
        paddingLeft: 8,
        paddingRight: 8,
      },
    },
    boxSearch: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    boxAvatar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    boxBreadCrumb: {
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        width: '40%',
        justifyContent: 'center',
      },
      [theme.breakpoints.between(0, 1200)]: {
        display: 'none',
      },
    },
    /** Botão circular das setas voltar/avançar. */
    navButton: {
      width: 32,
      height: 32,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'background-color .15s ease',
      '&:hover': {
        backgroundColor: colors.grayFeedbackBg,
      },
      [theme.breakpoints.between(0, 1200)]: {
        '&:hover': { backgroundColor: colors.purpleDarkMedium },
      },
    },
    iconArrowColor: {
      color: colors.grayMedium,
      [theme.breakpoints.between(0, 1200)]: {
        color: colors.white,
      },
    },
    avatar: {
      backgroundColor: colors.lilacLight,
      color: colors.purple,
      border: `1px solid ${palette.brandSoft}`,
    },
    boxMenuOutlinedIcon: {
      display: 'flex',
    },
  }),
)
